<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    종사자 정보-->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 종사자 정보</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">부서명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <vs-input
            v-else
            v-model="form.inputB_1"
            class="w-full flex-1"
          ></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">성명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <vs-input
            v-else
            v-model="form.inputB_2"
            class="w-full flex-1"
          ></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">성별</div>
          <vs-radio class="mr-4" v-model="form.inputB_3" vs-value="남" color="secondary" :disabled="board.readonly">남</vs-radio>
          <vs-radio v-model="form.inputB_3" vs-value="여" color="secondary" :disabled="board.readonly">여</vs-radio>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">생년월일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <date-selector v-else class="w-full flex-1" v-model="form.inputB_4" :readonly="board.readonly" />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">수행업무</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <vs-input
            v-else
            v-model="form.inputB_5"
            class="w-full flex-1"
          ></vs-input>
        </div>
      </div>
    </div>

    <!--    발병위험인자-->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 발병위험인자</h5>
        </vs-col>
      </vs-row>
      <vs-row class="my-4">
        <table class="mb-4 table-wrap">
          <tr>
            <th class="p-4 th-cell" colspan="2">문진</th>
            <th class="p-4 th-cell" colspan="2">생활습관 및 검사항목</th>
            <th class="p-4 th-cell" colspan="2">업무적 요인</th>
          </tr>

          <tr>
            <th class="p-4 th-cell" v-for="index in 6">{{index%2===1? '위험요인':'평가결과'}}</th>
          </tr>

          <tr>
            <th colspan="2" class="p-0 th-cell">
              <template>
                <table style="width: 100%;  border-spacing: 0;">
                  <tr v-for="row in form.risk_factors_1">
                    <td class="td-cell cell-head" width="50%">{{row.name}}</td>
                    <td class="p-2 td-cell flex" style="border-right: none;">
                      <div v-if="isPrint" class="print-input text-right" >{{ row.value }}</div>
                      <vs-input v-else class="w-full" v-model="row.value" :readonly="board.readonly" />
                    </td>
                  </tr>

                  <tr>
                    <td v-if="isPrint" class="p-2" style="border-right: 1px solid #cdcdcd;">
                      <div class="print-input text-right" >{{ form.risk_factor_1_A }}</div>
                    </td>
                    <td v-else class="p-2" style="border-right: 1px solid #cdcdcd;" >
                      <vs-input class="w-full" v-model="form.risk_factor_1_A" :readonly="board.readonly" />
                    </td>
                    <td class="p-2" style="border-right: none;">
                      <vs-input class="w-full" v-model="form.risk_factor_1_B" :readonly="board.readonly" />
                    </td>
                  </tr>
                </table>
              </template>
            </th>

            <th colspan="2" class="p-0 th-cell">
              <template>
                <table style="width: 100%;  border-spacing: 0;">
                  <tr v-for="row in form.risk_factors_2">
                    <td class="td-cell cell-head" width="50%">{{row.name}}</td>

                    <td v-if="row.check==null" class="p-2 td-cell flex" style="border-right: none;">
                      <div v-if="isPrint" class="print-input text-right" >{{ row.value }}</div>
                      <vs-input v-else class="w-full" v-model="row.value" :readonly="board.readonly" />
                    </td>
                    <td v-else class="td-cell flex" style="border-right: none;">
                      <div v-if="isPrint" class="print-input text-right p-2" >{{ row.value }}</div>
                      <vs-input v-else class="w-full p-2" v-model="row.value" :readonly="board.readonly" />
                      <div class="flex pl-2" style="width: 100px; height: 50px; border-left: 1px solid #cdcdcd;">
                        <span class="mr-2" style="align-self: center;">치료여부</span>
                        <template v-if="isPrint">
                          <div
                            class="item-box-check"
                            style="text-align: center;  align-self: center;"
                          >
                            <vs-icon icon="check" size="medium"></vs-icon>
                          </div>
                        </template>
                        <vs-checkbox
                          v-else
                          class="item-box-check"
                          :readonly="board.readonly"
                          v-model="row.check"
                        ></vs-checkbox>

                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td v-if="isPrint" class="p-2" style="border-right: 1px solid #cdcdcd;">
                      <div class="print-input text-right" >{{ form.risk_factor_2_A }}</div>
                    </td>
                    <td v-else class="p-2" style="border-right: 1px solid #cdcdcd;" >
                      <vs-input class="w-full" v-model="form.risk_factor_2_A" :readonly="board.readonly" />
                    </td>
                    <td class="p-2" style="border-right: none;">
                      <vs-input class="w-full" v-model="form.risk_factor_2_B" :readonly="board.readonly" />
                    </td>
                  </tr>
                </table>
              </template>
            </th>

            <th colspan="2" class="p-0 th-cell">
              <template>
                <table style="width: 100%;  border-spacing: 0;">
                  <tr v-for="row in form.risk_factors_3">
                    <td class="td-cell cell-head" width="50%">{{row.name}}</td>
                    <td class="p-2 td-cell flex" style="border-right: none;">
                      <div v-if="isPrint" class="print-input text-right" >{{ row.value }}</div>
                      <vs-input v-else class="w-full" v-model="row.value" :readonly="board.readonly" />
                    </td>
                  </tr>

                  <tr>
                    <td v-if="isPrint" class="p-2" style="border-right: 1px solid #cdcdcd;">
                      <div class="print-input text-right" >{{ form.risk_factor_3_A }}</div>
                    </td>
                    <td v-else class="p-2" style="border-right: 1px solid #cdcdcd;" >
                      <vs-input class="w-full" v-model="form.risk_factor_3_A" :readonly="board.readonly" />
                    </td>
                    <td class="p-2" style="border-right: none;">
                      <vs-input class="w-full" v-model="form.risk_factor_3_B" :readonly="board.readonly" />
                    </td>
                  </tr>
                </table>
              </template>
            </th>
          </tr>

          <tr>
            <th class="p-4 th-cell text-left" colspan="6">사후관리를 위한 위험요인 검토의견</th>
          </tr>

          <tr>
            <td class="th-cell text-left" colspan="6" style="background-color: white;">
              <table>
                <tr class="flex" style="align-items: center; height: 50px;">
                  <div class="px-4">1. 임상증상 및 동반질환 상태 검토 결과,</div>
                  <vs-input style="width: 250px;" v-model="form.result_1" :readonly="board.readonly" />
                  <div class="px-4">확인됨.</div>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td class="th-cell text-left" colspan="6" style="background-color: white;">
              <table>
                <tr class="flex" style="align-items: center; height: 50px;">
                  <div class="px-4">2. 생활습관 및 검사항목 검토 결과,</div>
                  <vs-input style="width: 250px;" v-model="form.result_2" :readonly="board.readonly" />
                  <div class="px-4">확인됨.</div>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td class="th-cell text-left" colspan="6" style="background-color: white;">
              <table>
                <tr class="flex" style="align-items: center; height: 50px;">
                  <div class="px-4">3. 업무적 요인에 대한 검토 결과,</div>
                  <vs-input style="width: 250px;" v-model="form.result_3" :readonly="board.readonly" />
                  <div class="px-4">확인됨.</div>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <th class="p-4 th-cell" colspan="1">종합의견</th>
            <td class="p-4 th-cell" colspan="5" style="background-color: white; text-align: left">
              <vs-radio class="mr-4" v-model="form.result_4" vs-value="적합" color="secondary" :disabled="board.readonly">남</vs-radio>
              <vs-radio v-model="form.result_4" vs-value="부적합" color="secondary" :disabled="board.readonly">여</vs-radio>
            </td>
          </tr>

          <tr>
            <td class="p-4" colspan="6"
                style="background-color: white;
                text-align: left;
                border-right: 1px solid #cdcdcd;
                border-bottom: 1px solid #cdcdcd;">
              <div class="pb-4 title">조건부 적합 또는 부적합의 경우, 해당 조건 기술할 것.</div>

              <p v-if="isPrint" class="print-textarea flex-1">{{ form.result_5 }}</p>
              <vs-textarea
                :readonly="board.readonly"
                v-else
                v-model="form.result_5"
                class="flex-1 w-full"
                rows="5"
              />

              <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
                <div class="col-span-4 flex items-center">
                  <div class="label-text mr-4">생년월일</div>
                  <p v-if="isPrint" class="print-input flex-1">
                    {{ form.result_6 }}
                  </p>
                  <date-selector
                    v-else
                    :readonly="board.readonly"
                    class="w-full flex-1"
                    v-model="form.result_6"
                  />
                </div>
                <div class="col-span-4 flex items-center">
                  <div class="label-text mr-4">의사면허번호</div>
                  <p v-if="isPrint" class="print-input flex-1">{{ form.result_7 }}</p>
                  <vs-input
                    v-else
                    :readonly="board.readonly"
                    v-model="form.result_7"
                    class="w-full flex-1"
                  ></vs-input>
                  <div class="pl-2">호</div>
                </div>
                <div class="col-span-2 flex items-center">
                  <div class="mr-4">이름</div>
                  <p v-if="isPrint" class="print-input flex-1">{{ form.result_8 }}</p>
                  <vs-input
                    v-else
                    :readonly="board.readonly"
                    v-model="form.result_8"
                    class="w-full flex-1"
                  ></vs-input>
                  <div class="pl-2">호</div>
                </div>
                <div class="col-span-2 item-area">
                  <div class="mr-4">서명</div>
                  <sign-field v-if="!isPrint && !board.readonly"  v-model="form.result_9" class="w-full flex-1 p-1"/>
                  <div v-else class="w-full flex-1 p-1">
                    <img v-if="form.result_9" :src="form.result_9" width="100%" alt="Signature" class="signatureImg" />
                    <div v-else class="signatureImg"></div>
                  </div>
                </div>
              </div>


            </td>
          </tr>

        </table>
      </vs-row>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector.vue";
import SignField from "@/components/SignField.vue";

export default {
  components: {
    SignField,
    DateSelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        inputB_1: '',
        inputB_2: '',
        inputB_3: '',
        inputB_4: '',
        inputB_5: '',

        inputC_1: '',
        inputC_2: '',
        inputC_3: '',

        risk_factors_1: [
          {name: '뇌경색', value: '',},
          {name: '뇌출혈', value: '',},
          {name: '심근경색', value: '',},
          {name: '대동맥박리', value: '',},
          {name: '협심증', value: '',},
          {name: '만성신장질환', value: '',},
          {name: '가족력', value: '',},
        ],
        risk_factors_2: [
          {name: '체중/허리둘레', value: '',},
          {name: '신체활동', value: '',},
          {name: '음주', value: '',},
          {name: '흡연', value: '',},
          {name: '혈압', value: '', check:false},
          {name: '공복혈당/HbA1c', value: '', check:false},
          {name: '콜레스테롤', value: '', check:false},
        ],
        risk_factors_3: [
          {name: '장시간', value: '',},
          {name: '교대제(야간)', value: '',},
          {name: '유해작업환경', value: '',},
          {name: '일정변경/출장', value: '',},
          {name: '정신적긴장', value: '',},
          {name: '육체적강도', value: '',},
          {name: '휴일부족', value: '',},
        ],
        risk_factor_1_A: '',
        risk_factor_1_B: '',
        risk_factor_2_A: '',
        risk_factor_2_B: '',
        risk_factor_3_A: '',
        risk_factor_3_B: '',
        result_1: '',
        result_2: '',
        result_3: '',
        result_4: '',
        result_5: '',
        result_6: '',
        result_7: '',
        result_8: '',
        result_9: '',

        stdInfo: {},
        fileList: [],
      },
    };
  },
  methods: {
    checkForm (value, text, indexRows) {
      if (text === 'family_disease') {
        this.form.family_disease[indexRows].is_checked = value.target.checked
      } else if (text === 'organ_damage_1') {
        this.form.organ_damage_1[indexRows].is_checked = value.target.checked
      } else if (text === 'organ_damage_2') {
        this.form.organ_damage_2[indexRows].is_checked = value.target.checked
      }
    }
  },
};
</script>


<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
.table-wrap {
  width: 100%;
  border-spacing: 0;
  border-top: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;
}

.th-cell {
  white-space: nowrap;
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;
  background-color: #f9f9f9;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
}
//
//.th-cell:nth-child(1) {
//  max-width: 130px;
//  width: 130px;
//}
//
//.th-cell:nth-child(2) {
//  max-width: 390px;
//  width: 390px;
//}

.td-cell {
  font-weight: 500;
  white-space: nowrap;
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;
  height: 50px;
}
//.td-cell:nth-child(1) {
//  text-align: center;
//}
.cell-head {
  text-align: center;
  background-color: #f9f9f9;
}
.input-small {
  width: 95px;
}
</style>
